import { type WritableDraft } from 'immer';
import { type Observable, of } from 'rxjs';

import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type EngineState } from '../../../+state/engine';
import {
  AbstractAiElementHandler,
  applyFieldSize,
  getElement,
  getInitialProps,
  patchFieldLabel,
  upsertElement,
} from '../../../ai';

import { type CheckboxInputContext } from './checkbox-input.definition';

export class CheckboxInputElementHandler extends AbstractAiElementHandler<'checkboxInput'> {
  readonly type = 'checkboxInput';

  prepare(context: CheckboxInputContext): Observable<CheckboxInputContext> {
    this.resolveElementIcon(context.element);
    return of(context);
  }

  process(context: CheckboxInputContext, draft: WritableDraft<EngineState>): void {
    let props: PartialPropsOf<'checkboxInput'> = getInitialProps<'checkboxInput'>(
      draft,
      context.element.id,
      {},
    );
    props = patchFieldLabel<'checkboxInput'>(props, context.element);

    if (context.element.isReadOnly !== undefined) {
      props = applyPropsPatch<'checkboxInput'>(props, {
        content: { input: { readonly: context.element.isReadOnly } },
      });
    }

    const { elementId } = upsertElement(draft, context, props);
    applyFieldSize<'checkboxInput'>(getElement(draft, elementId, 'checkboxInput'), context.element);
  }
}
